import Vue from "vue";
import {getField, updateField} from "vuex-map-fields";
import {axiosCall} from "@/utils/axiosCall";

function initialState() {
  return {
    organizationsByStatus: {loading: true, data: []},
    organizationsByCountry: {loading: true, data: []},
    organizationsByRegion: {loading: true, data: []},
    organizationsByType: {loading: true, data: []},
    impactedWorkers: {loading: true, data: {men: 0, women: 0}},
    employeesByOrganizationSize: {loading: true, data: []},
    organizationsByEconomicActivity: {loading: true, data: []},
    opinionSurveyReport: {loading: true, data: []},
    violenceSurveyReport: {loading: true, data: []},
    selectedRegionInWidget: null,
    filters: {}
  };
}

const state = initialState;

const getters = {
  getOrganizationsByStatus: (state) => state.organizationsByStatus,
  getOrganizationsByCountry: (state) => state.organizationsByCountry,
  getTotalCountries: (state) => state.organizationsByCountry.data.reduce((acc, current) => ++acc, 0),
  getTotalOrganizations: (state) => state.organizationsByStatus.data.reduce((acc, current) => acc + current.value, 0),
  getTotalOrganizationsByType: (state) => state.organizationsByType.data.reduce((acc, current) => acc + current.count, 0),
  getOrganizationsByRegion: (state) => state.organizationsByRegion,
  getTotalOrganizationsByRegion: (state) => state.organizationsByRegion.data.reduce((acc, current) => acc + current.count, 0),
  getOrganizationsByType: (state) => state.organizationsByType,
  getImpactedWorkers: (state) => state.impactedWorkers,
  getEmployeesByOrganizationSize: (state) => state.employeesByOrganizationSize,
  getTotalOrganizationsByOrganizationSize: (state) => state.employeesByOrganizationSize.data.reduce((acc, current) => acc + current.count, 0),
  getOrganizationsByEconomicActivity: (state) => state.organizationsByEconomicActivity,
  getTotalOrganizationsByEconomicActivity: (state) => state.organizationsByEconomicActivity.data.reduce((acc, current) => acc + current.count, 0),
  getOpinionSurveyReport: (state) => state.opinionSurveyReport,
  getViolenceSurveyReport: (state) => state.violenceSurveyReport,
  getSelectedRegionInWidget: (state) => state.selectedRegionInWidget,
};

const actions = {
  SET_NEW_FILTERS: async ({dispatch, commit}, data) => {
    commit('setFilters', data);
    dispatch('REFRESH_DASHBOARD');
  },
  REFRESH_DASHBOARD: async ({dispatch}) => {
    dispatch("GET_ORGANIZATIONS_BY_STATUS");
    dispatch("GET_ORGANIZATIONS_BY_COUNTRY");
    dispatch("GET_ORGANIZATIONS_BY_REGION");
    dispatch("GET_ORGANIZATIONS_BY_TYPE");
    dispatch("GET_IMPACTED_WORKERS");
    dispatch("GET_EMPLOYEES_BY_ORGANIZATION_SIZE");
    dispatch("GET_ORGANIZATIONS_BY_ECONOMIC_ACTIVITY");
    dispatch("GET_OPINION_SURVEY_REPORT");
    dispatch("GET_VIOLENCE_SURVEY_REPORT");
  },
  GET_ORGANIZATIONS_BY_STATUS: async ({commit, state}) => {
    await commit("setLoadingOrganizationsByStatus", true);
    var resp = await axiosCall({
      url: "new-dashboard/organizations-by-status",
      method: "POST",
      data: state.filters,
    });

    commit("setOrganizationsByStatus", resp.data);
    commit("setLoadingOrganizationsByStatus", false);
  },
  GET_ORGANIZATIONS_BY_COUNTRY: async ({commit, state}) => {
    await commit("setLoadingOrganizationsByCountry", true);
    var resp = await axiosCall({
      url: "new-dashboard/organizations-by-country",
      method: "POST",
      data: state.filters,
    });

    commit("setOrganizationsByCountry", resp.data);
    commit("setLoadingOrganizationsByCountry", false);
  },
  GET_ORGANIZATIONS_BY_REGION: async ({commit, state}) => {
    await commit("setLoadingOrganizationsByRegion", true);
    var resp = await axiosCall({
      url: "new-dashboard/organizations-by-region",
      method: "POST",
      data: state.filters,
    });

    commit("setOrganizationsByRegion", resp.data);
    commit("setLoadingOrganizationsByRegion", false);
  },
  GET_ORGANIZATIONS_BY_TYPE: async ({commit, state}) => {
    await commit("setLoadingOrganizationsByType", true);
    var resp = await axiosCall({
      url: "new-dashboard/organizations-by-type",
      method: "POST",
      data: state.filters,
    });

    commit("setOrganizationsByType", resp.data);
    commit("setLoadingOrganizationsByType", false);
  },
  GET_IMPACTED_WORKERS: async ({commit, state}) => {
    await commit("setLoadingImpactedWorkers", true);
    var resp = await axiosCall({
      url: "new-dashboard/impacted-workers",
      method: "POST",
      data: state.filters,
    });

    commit("setImpactedWorkers", resp.data);
    commit("setLoadingImpactedWorkers", false);
  },
  GET_EMPLOYEES_BY_ORGANIZATION_SIZE: async ({commit, state}) => {
    await commit("setLoadingEmployeesByOrganizationSize", true);
    var resp = await axiosCall({
      url: "new-dashboard/employees-by-organization-size",
      method: "POST",
      data: state.filters,
    });

    commit("setEmployeesByOrganizationSize", [...resp.data]);
    commit("setLoadingEmployeesByOrganizationSize", false);
  },
  GET_ORGANIZATIONS_BY_ECONOMIC_ACTIVITY: async ({commit, state}) => {
    await commit("setLoadingOrganizationsByEconomicActivity", true);
    var resp = await axiosCall({
      url: "new-dashboard/organizations-by-economic-activity",
      method: "POST",
      data: state.filters,
    });

    commit("setOrganizationsByEconomicActivity", resp.data.filter((s) => !!s._id).map((s) => ({
      ...s,
      fullName: s._id,
      _id: `${s._id}_short`
    })));
    commit("setLoadingOrganizationsByEconomicActivity", false);
  },
  GET_OPINION_SURVEY_REPORT: async ({commit, state}) => {
    await commit("setLoadingOpinionSurveyReport", true);
    var resp = await axiosCall({
      url: "new-dashboard/survey/opinion",
      method: "POST",
      data: state.filters,
    });

    commit("setOpinionSurveyReport", resp.data);
    commit("setLoadingOpinionSurveyReport", false);
  },
  GET_VIOLENCE_SURVEY_REPORT: async ({commit, state}) => {
    await commit("setLoadingViolenceSurveyReport", true);
    var resp = await axiosCall({
      url: "new-dashboard/survey/violence",
      method: "POST",
      data: state.filters,
    });

    commit("setViolenceSurveyReport", resp.data);
    commit("setLoadingViolenceSurveyReport", false);
  },
};

const mutations = {
  setLoadingOrganizationsByStatus: (state, loading) => {
    state.organizationsByStatus.loading = loading;
  },
  setOrganizationsByStatus: (state, data) => {
    state.organizationsByStatus.data = data;
  },
  setLoadingOrganizationsByCountry: (state, loading) => {
    state.organizationsByCountry.loading = loading;
  },
  setOrganizationsByCountry: (state, data) => {
    state.organizationsByCountry.data = data;
  },
  setLoadingOrganizationsByRegion: (state, loading) => {
    state.organizationsByRegion.loading = loading;
  },
  setOrganizationsByRegion: (state, data) => {
    state.organizationsByRegion.data = data;
  },
  setLoadingOrganizationsByType: (state, loading) => {
    state.organizationsByType.loading = loading;
  },
  setOrganizationsByType: (state, data) => {
    state.organizationsByType.data = data;
  },
  setLoadingImpactedWorkers: (state, loading) => {
    state.impactedWorkers.loading = loading;
  },
  setImpactedWorkers: (state, data) => {
    state.impactedWorkers.data = data;
  },
  setLoadingEmployeesByOrganizationSize: (state, loading) => {
    state.employeesByOrganizationSize.loading = loading;
  },
  setEmployeesByOrganizationSize: (state, data) => {
    state.employeesByOrganizationSize.data = data;
  },
  setLoadingOrganizationsByEconomicActivity: (state, loading) => {
    state.organizationsByEconomicActivity.loading = loading;
  },
  setOrganizationsByEconomicActivity: (state, data) => {
    state.organizationsByEconomicActivity.data = data;
  },
  setLoadingOpinionSurveyReport: (state, loading) => {
    state.opinionSurveyReport.loading = loading;
  },
  setOpinionSurveyReport: (state, data) => {
    state.opinionSurveyReport.data = data;
  },
  setLoadingViolenceSurveyReport: (state, loading) => {
    state.violenceSurveyReport.loading = loading;
  },
  setViolenceSurveyReport: (state, data) => {
    state.violenceSurveyReport.data = data;
  },
  setSelectedRegionInWidget: (state, data) => {
    state.selectedRegionInWidget = data;
  },
  setFilters: (state, filters) => {
    state.filters = filters;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
